import React, { useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@mui/material";
// import filterIcon from './../../assets/icons/filter 1.png'
// import searchIcon from './../../assets/icons/searchIcon 1.png'

import filterIcon from "./../../../../assets/icons/filter 1.png";
import searchIcon from "./../../../../assets/icons/searchIcon 1.png";
import AddItemDialogComponent from "./AddItemDialog.tsx";

import FilterComponents from "../FilterComponents.tsx";
import SectionTable from "../SectionTable.tsx";
import burger from "./../../../../assets/icons/burger.png";
import arrowDown from "../../../../assets/icons/arrowDown.png";
import arrowUp from "../../../../assets/icons/arrowup.png";

//table
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import AddMenuDialog from "../AddMenuDialog.tsx";

import Tabs from "@mui/material/Tabs";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import axios from "axios";
import "./AddMenu.css";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import ediPencil from "./../../../../assets/icons/editPencil.png";
import EditMenuDialog from "../EditMenuDialog.tsx";
import bin from "./../../../../assets/icons/recycle-binColor.png";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import { toast } from "react-toastify";
import LoadingView from "../../../components/LoadingView/LoadingView";
import link from "./../../../../assets/icons/link.png";
import { Kitchen } from "@mui/icons-material";

import MenuUnavailableModel from "./MenuUnavailableModel.tsx";

import MenuLinkDialog from './../MenuLinkDialog.tsx';

function AddMenu(props) {
  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [selectedData, setSelectedData] = useState({});

  const [openAddSection, setOpenAddSection] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [editdialogType, seteditDialogType] = useState("");
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [openLinkConfirmaitonModal, setopenLinkConfirmaitonModal] = useState(false);

  const errorToast = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleAddMenuDialogData = (data) => {
    setSelectedData(data);
    loadData();
  };

  const HandleNothing = () => {
  };

  const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType("Add Menu");
  };

  const handleAddItem = (AddSectionData) => {
    setOpenAddSection(AddSectionData);
    setOpenEditMenu(AddSectionData);
    setOpenMenuUnavailableDialog(AddSectionData)
    loadData();
  };

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);
  const [selectedDataRowsCount, setSelectedDatarowsCount] = React.useState([]);
  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const deleteBin = () => {
    var url = apiAddress + "/api/Menu/DeleteMenu";

    axios.put(url, selectedDataRows).then((response) => {
      toast.success("successfully deleted", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      loadData();
    });
    setopenConfirmaitonModal(false);
  };

  const LinkMenu = () => {
    var url = apiAddress + "/api/Menu/LinkMenus";

    axios.put(url, selectedDataRows).then((response) => {
      toast.success("Menus successfully Linked", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      //loadData();
    });
    setopenLinkConfirmaitonModal(false);
  };
  //Toggle dialog

  const [openDialog, setOpenDialog] = useState(false);
  const [openMenuUnavailableDialog, setOpenMenuUnavailableDialog] = useState(false);
  const [openMenuAvailableDialog, setOpenMenuAvailableDialog] = useState(false);
  const [IsactiveDialogType, setIsactiveDialogType] = useState("");
  const [openDialogisactive, setopenDialogisactive] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const handleToggleChange = (event, id) => {
    console.log(id)
    if (id.isactive == false) {
      setSelectedRowId(id.id);
      setOpenMenuAvailableDialog(true);
    } else {
      setOpenMenuUnavailableDialog(true);
      setSelectedRowId(id.id);
      //setSelectedDataRow(id);
    }
  };

  //Togle dialog
  //table start

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [OpenEditMenu, setOpenEditMenu] = useState(false);
  const [EditMenudObj, setEditMenudObj] = useState();
  const onEditClick = async (props) => {


    var iconObj;
    var obj = dataRows.find((x) => x.id == props);
    console.log(obj);

    // await axios.get(apiAddress + "/api/Icon/getallicon").then((response) => {
    //   console.log(response.data);

    //   response.data.map((dt, i) => {
    //     if (dt.url == obj.url) {
    //       console.log("url matched");
    //       iconObj = { code: dt.id, icon: dt.url, label: dt.name };
    //     }
    //   });
    // });
    var editObj = { obj, iconObj };
    if (!!editObj.obj == true) {
      setEditMenudObj(editObj);
      setOpenEditMenu(true);
      seteditDialogType('Edit Menu');
    }
  };
  const [lastRank, setLastRank] = useState(1);

  const columns = [
    {

      field: "displayOrder",
      headerName: "Display Order",
      renderCell: (params) => (

        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <span
            className={`${params.row.displayOrder == 1 ? "deselct" : ""}`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              changeOrder(params.row, 2);
            }}
          >
            <img src={arrowUp} style={{ width: "1rem" }} />
          </span>
          <input
            type="number"
            className="form-control"
            style={{ width: "7rem" }}
            defaultValue={params.value}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                changeOrderByTextBox(event, params.row);
              }
            }}
          />
          <span
            className={`${params.row.displayOrder == lastRank - 1 ? "deselct" : ""
              }`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              changeOrder(params.row, 1);
            }}
          >
            <img src={arrowDown} style={{ width: "1rem" }} />
          </span>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "menuName",
      headerName: "Menu Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      renderCell: (params) => (
        <div className="d-flex " style={{ gap: "10px" }}>
          <span
            // onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.value) }}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {params.value}
          </span>
          {/* {
          editPermission
            ?
            <div
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                onEditClick(params.row.id);
              }}
            >
              <img src={ediPencil} alt="" style={{ width: "1rem" }} />
            </div>
            :
            ""
        } */}
          <div
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              onEditClick(params.row.id);
            }}
          >
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
        </div>
      )
    },
    {
      field: "typeName",
      headerName: "Type Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "url",
      headerName: "Icon",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <img src={params.value} alt="" style={{ width: "1.5rem" }} />
      ),
    },
    {
      field: "isactive",
      headerName: "Active Status",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          onChange={(event) => handleToggleChange(event, params.row)}
          color="primary"
          inputProps={{ "aria-label": "toggle" }}
          id={params.row.id}
        />
      ),
    },
  ];

  const [Loading, setLoading] = React.useState(false);

  const changeOrder = (props, type) => {
    console.log(props);


    setLoading(true);
    axios
      .put(
        apiAddress +
        "/api/Menu/updaterankmenu?id=" +
        props.id +
        "&status=" +
        type
      )
      .then((response) => {
        console.log(response.data);
        setDataRows([]);
        toast.success("Successfully updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        //loadData(selectedMenu);
        loadData()
      });
  };

  const changeOrderByTextBox = (props, type) => {
    console.log(props.target.value);
    console.log(type);

    if (props.target.value != "") {
      setLoading(true);
      if (lastRank - 1 < props.target.value || props.target.value == 0) {
        setLoading(false);
        toast.error("please select a valid number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else if (type.displayOrder == props.target.value) {
        setLoading(false);
        toast.error("please change the rank", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else {
        axios
          .put(
            apiAddress +
            "/api/Menu/updaterankwithtextboxmenu?id=" +
            type.id +
            "&newRank=" +
            props.target.value
          )
          .then((response) => {
            console.log(response.data);
            setDataRows([]);
            toast.success("Successfully updated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            loadData();
          });
      }
    }
  };

  const [dataRows, setDataRows] = useState([]);
  // [
  //     { id: 1, checkbox: '', firstName: 'Leo', lastName: 'Leo', userName: 'Leo', Designations: 'General Manager', RestaurantName: "Pot Kettle Black London", ContactNumber: "098951685461", Address: "London", DOB: "19-may-2023" },
  //     { id: 2, checkbox: '', firstName: 'Leo', lastName: 'Leo', userName: 'Leo', Designations: 'General Manager', RestaurantName: "Pot Kettle Black London", ContactNumber: "098951685461", Address: "London", DOB: "19-may-2023" },
  // ];
  const apiAddress = process.env.REACT_APP_SECRET;

  const RestaurantLocaltoken = JSON.parse(localStorage.getItem('restaurant'));
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const restaurant = localStorage.getItem("restaurant");
    var res = JSON.parse(restaurant);
    console.log(res);

    axios({
      method: "get",
      url:
        apiAddress + "/api/menu/getallmenuwithdetails?restaurantId=" + res.id,
    })
      .then((response) => {
        console.log(response);
        var list = [];
        if (response.data.length > 0) {
          response.data.map((dt, i) => {
            var obj = {
              id: dt.id,
              menuName: dt.menuName,
              typeName: dt.typeName,
              url: dt.url,
              isactive: dt.isActive,
              displayOrder: dt.rank,
              restaurantId: res.id,
              restaurantName: res.name,
              restaurantIsDelivery: dt.restaurantIsDelivery,
              kitchenId: dt.kitchenId,
              KitchenName: dt.kitchenName,
              scheduleId: dt.scheduleId,
              isDelivery: dt.isDelivery,
              isCollectionOnly: dt.isCollectionOnly,
              restaurantIsCollectionOnly: dt.restaurantIsCollectionOnly

              // .filter(item => item.restaurantId === RestaurantLocaltoken.id )
              // .map(item => item.rank)
            };
            list.push(obj);
            console.log(list);
          });
          setDataRows(list);
          setLoading(false);
          if (list.length > 0) {
            console.log(list.length);
            console.log(list[list.length - 1].displayOrder);
            var rank = list[list.length - 1].displayOrder;

            setLastRank(rank + 1);
          } else {
            setLastRank(1);
          }
        }
      })
      .catch((error) => { });
  };

  const [deletePermission, setDeletePermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [addPermission, setAddPermission] = useState(false);

  useEffect(() => {
    const permissions = localStorage.getItem('permissions');
    if (permissions !== null) {
      const permissionParsed = JSON.parse(permissions);
      const menuPermission = permissionParsed?.find(per => per.uiName === "Menu");

      setDeletePermission(menuPermission?.functionNames.includes("delete"));
      setEditPermission(menuPermission?.functionNames.includes("Edit"));
      setAddPermission(menuPermission?.functionNames.includes("Add"));
    }
  }, [])

  const [openLinkModal, setopenLinkModal] = useState(false);
  const handleLinkModel = () => {
    setopenLinkModal(true);
  }
  const hanldeLinkmodalclose = () => {
    setopenLinkModal(false);
  }

  const MenuActivate = () => {
    console.log(selectedRowId)

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress + "/api/menu/SetMenuAvailable?menuId=" + selectedRowId,
      })
        .then((response) => {
          toast.success("Menu activated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadData();
        });
      setOpenMenuAvailableDialog(false);
    }
  }
  //table end

  return (
    <div>
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        mb={2}
      >
        <SweetAlertModal
          headerText={"Are you sure?"}
          bodyText={"You want to delete this?"}
          open={openConfirmaitonModal}
          onyes={deleteBin}
          close={() => {
            setopenConfirmaitonModal(false);
          }}
        />
        <SweetAlertModal
          headerText={"Do Want Link These Menus?"}
          bodyText={""}
          open={openLinkConfirmaitonModal}
          onyes={LinkMenu}
          close={() => {
            setopenLinkConfirmaitonModal(false);
          }}
        />
        <SweetAlertModal
          headerText={"Are you sure?"}
          bodyText={"This action will activate this menu"}
          open={openMenuAvailableDialog}
          onyes={MenuActivate}
          close={() => {
            setOpenMenuAvailableDialog(false);
          }}
        />

        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              {/* {
                addPermission
                  ?
                  <Button
                    color="primary"
                    size="medium"
                    variant="contained"
                    style={{ borderRadius: "50%", minWidth: "auto" }}
                    onClick={handleClickOpen}
                  >
                    +
                  </Button>
                  :
                  ""
              } */}
            </Grid>
            <Grid item>
              <Button
                color="primary"
                size="medium"
                variant="contained"
                style={{ borderRadius: "50%", minWidth: "auto" }}
                onClick={handleClickOpen}
              >
                +
              </Button>
            </Grid>
            {/* <Grid item>
              <img src={filterIcon} alt="" style={{ width: "1rem" }} />
            </Grid>
            <Grid item>Add Filter</Grid> */}
            {/* <Grid item>
              <div className="roundedCorner">
                <img
                  src={link}
                  alt=""
                  style={{ width: "1rem" }}
                  onClick={() => {
                    selectedDataRows.length == 0
                      ? errorToast("Please select menu")
                      : setopenLinkConfirmaitonModal(true);
                  }}
                />
              </div>
            </Grid> */}
            <Grid item>
              <div className="roundedCorner">
                <img
                  src={link}
                  alt=""
                  style={{ width: "1rem" }}
                  onClick={() => {
                    handleLinkModel()
                  }}
                />
              </div>
            </Grid>
            <Grid item>
              {
                deletePermission
                  ?
                  <div className="roundedCorner">
                    <img
                      src={bin}
                      alt=""
                      style={{ width: "1rem" }}
                      onClick={() => {
                        selectedDataRows.length == 0
                          ? errorToast("Please select menu")
                          : setopenConfirmaitonModal(true);
                      }}
                    />
                  </div>
                  :
                  ""
              }
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Grid>
        <Grid item></Grid>
      </Grid>

      <CustomDataGrid
        columns={columns}
        dataRows={dataRows}
        getselectedData={getselectedData}
        isLoading={Loading}
      />
      <AddMenuDialog
        open={openAddSection}
        dialogType={dialogType}
        onHandleAddItem={handleAddItem}
        onHandleSelectedData={handleAddMenuDialogData}
        loaddataonfly={HandleNothing}
      />
      {OpenEditMenu &&
        <EditMenuDialog
          open={OpenEditMenu}
          dialogType={dialogType}
          onHandleAddItem={handleAddItem}
          eidtData={EditMenudObj}
        />}

      {openMenuUnavailableDialog &&
        <MenuUnavailableModel
          open={openMenuUnavailableDialog}
          selectedMenuId={selectedRowId}
          onHandleAddItem={handleAddItem}
        //eidtData={EditMenudObj}
        />}

      <MenuLinkDialog
        open={openLinkModal}
        linkmodalclose={hanldeLinkmodalclose}
        onHandlelinkModelClose={hanldeLinkmodalclose}
        Openfrom={"Main"}
      // onHandleSelectedData={handleAddMenuDialogData}
      />
    </div>
  );
}

export default AddMenu;
